import * as React from "react";
import {
    PlasmicProjectSettings,
    DefaultProjectSettingsProps
} from "./plasmic/main/PlasmicProjectSettings";
import {useRef, useState} from "react";
import {TextInputRefValue} from "@plasmicapp/react-web";
import {useGoogleLogin} from "@react-oauth/google";
import {linkGoogleAccount} from "../api/fetch-requests";

export interface ProjectSettingsProps extends DefaultProjectSettingsProps {
    project?: any,
    onChange: (projectChanges: any) => void,
    onClose: () => void
}

type states = "notionEnabled";

function ProjectSettings({project, onChange, onClose, ...rest}: ProjectSettingsProps) {
    const [state, setState] = useState<states[]>(project?.notionEnabled ? ["notionEnabled"] : []);
    const notionKey = useRef<TextInputRefValue>(null);
    const databaseId = useRef<TextInputRefValue>(null);

    const login = useGoogleLogin({
        onSuccess: codeResponse => {
            console.log(codeResponse)
            const result = linkGoogleAccount(codeResponse);
            console.log(result)
        },
        flow: 'auth-code',
    });

    const notionKeyValue = project?.notionKey ? project.notionKey : '';
    const databaseIdValue = project?.databaseId ? project.databaseId : '';

    const projectLink = project?.id !== 'local' ? 'https://bimmy.netlify.app/project/' + project?.id : 'Local Project';


    function finishEditing(textbox: any, defaultValue: string, key: string) {
        const input = textbox.current?.getInput()?.value;
        if (input && input !== defaultValue) {
            const changes: any = {};
            changes[key] = input;
            onChange(changes);
        }
    }

    return <PlasmicProjectSettings
        {...rest}
        root={{
            onClick: (e) => {
                e.stopPropagation();
            }
        }}
        state={state}
        closeHandle={{
            onClick: onClose
        }}
        googleSignIn={{
            onClick: () => login()
        }}
        projectLink={{
            defaultValue: projectLink
        }}
        copyProjectLink={{
            onClick: () => navigator.clipboard.writeText(projectLink)
        }}
        notionHandle={{
            onClick: () => {
                if (project?.status === "notStored") return
                if (state.includes('notionEnabled')) {
                    onChange({notionEnabled: false});
                    setState((state) => state.filter((s) => s !== 'notionEnabled'));
                } else {
                    onChange({notionEnabled: true});
                    setState((state) => [...state, 'notionEnabled']);
                }
            }
        }}
        notionSwitch={{
            isChecked: state.includes('notionEnabled')
        }}
        notionKey={{
            ref: notionKey,
            defaultValue: notionKeyValue,
            onKeyDown: (event: any) => {
                if (event.key === 'Enter') {
                    finishEditing(notionKey, notionKeyValue, 'notionKey');
                }
            },
            onBlur: () => {
                finishEditing(notionKey, notionKeyValue, 'notionKey');
            }
        }}
        databaseId={{
            ref: databaseId,
            defaultValue: databaseIdValue,
            onKeyDown: (event: any) => {
                if (event.key === 'Enter') {
                    finishEditing(databaseId, databaseIdValue, 'databaseId');
                }
            },
            onBlur: () => {
                finishEditing(databaseId, databaseIdValue, 'databaseId');
            }
        }}
    />;
}

export default ProjectSettings;
